import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { IconButton } from '@dbk//ui-buttons';
import { Close } from '@dbk//ui-icons';
import { contextTypes } from '../common';
import getCloseBtnSVGcolor from './close-btn.styles';

// Using js to set color because unable to override inline svg attributes in css

class CloseBtn extends React.Component {
  static propTypes = {
    onClick: PropTypes.func,
  };
  static defaultProps = {
    onClick: noop,
  };
  static contextTypes = contextTypes;
  constructor() {
    super();
    this.state = {
      interaction: 'none',
    };
  }
  setInteraction = (type) => () => {
    this.setState({
      interaction: type,
    });
  };
  render() {
    return (
      <IconButton
        onMouseEnter={this.setInteraction('hover')}
        onMouseLeave={this.setInteraction('none')}
        onMouseDown={this.setInteraction('active')}
        onMouseUp={this.hover}
        onClick={this.props.onClick}
        className="close-btn"
      >
        <Close
          color={getCloseBtnSVGcolor(
            this.state.interaction,
            this.context.inverse
          )}
        />
      </IconButton>
    );
  }
}

export default CloseBtn;
